module.exports = __webpack_public_path__ + "static/img/1.758972f2.png";